import axios from 'axios'
import { API_URL } from '@/config/api.config'

export const facilityServer={
    /**
     * 新增设施
     */
    addFacility(facilityData) {
        return axios.post(`${API_URL}/facility`, facilityData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if (response.status === 201 || response.status === 200) {
                return response;
            } else {
                throw new Error(response.data?.message || '添加设施失败');
            }
        });
    },

    /**
     * 获取设施列表
     */
    getFacility(){
        return axios.get(`${API_URL}/facility`);
    },

    /**
     * 获取单个设施 
     */
    getFacilityById(id){
        return axios.get(`${API_URL}/facility/${id}`);
    },

    /**
     * 更新设施 
     */
    updateFacility(id, facilityData) {
        console.log('设施数据:', facilityData);
    
        let formData;
        if (facilityData instanceof FormData) {
            formData = facilityData;
        } else {
            formData = new FormData();
            for (const key in facilityData) {
                if (key === 'image') {
                    if (facilityData.image instanceof File) {
                        formData.append('image', facilityData.image, facilityData.image.name);
                    } else if (Array.isArray(facilityData.image) && facilityData.image.length > 0) {
                        const imageFile = facilityData.image[0].raw || facilityData.image[0];
                        if (imageFile instanceof File) {
                            formData.append('image', imageFile, imageFile.name);
                        } else if (typeof imageFile === 'string') {
                            formData.append('image', imageFile);
                        }
                    }
                } else {
                    formData.append(key, facilityData[key]);
                }
            }
        }

    
        return axios.post(`${API_URL}/facility/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    /**
     * 删除设施
     */
    deleteFacilityById(id){
        return axios.delete(`${API_URL}/facility/${id}`);
    },

    /**
     * 更新设施排序序号
     */
    updateFacilityOrder: (data) => {
        return axios.put(`${API_URL}/facility/order`, data);
    },

    /**
     * 更新设施状态
     */
    updateFacilityStatus: (id,isActive) => {
        return axios.put(`${API_URL}/facility/${id}/status`,  { is_active: isActive });
    },
    
    /**
     * 获取设施组选项
     */
    getFacilityGroup(){
        return axios.get(`${API_URL}/facility-group`);
    }

}
